import { create } from "zustand";

export interface CreditCardModalState {
  isOpen: boolean;
  quotationId: string | null;
  companyId: number | null;
  open(quotationId: string, companyId: number): void;
  close(): void;
}

export const useCreditCardModalStore = create<CreditCardModalState>((set) => {
  return {
    isOpen: false,
    quotationId: null,
    companyId: null,
    open: (quotationId: string, companyId: number) =>
      set(() => ({
        isOpen: true,
        quotationId,
        companyId,
      })),

    close: () =>
      set(() => ({
        isOpen: false,
        quotationId: null,
        companyId: null,
      })),
  };
});
